import http from '../../../../libs/http'
export default (categoriId = null, queryParams = {}) => {
  let endpoint = `${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/categories`
  if (categoriId) endpoint += `/${categoriId}`
  return http.get(endpoint, { params: { ...queryParams } })
}
